import { BANDWIDTH_THRESHOLDS } from '@/modules/webrtc/agora/const';

export default {
  setQualityOfNetwork(quality) {
    if (quality >= BANDWIDTH_THRESHOLDS.poor.value) {
      return BANDWIDTH_THRESHOLDS.poor;
    } else if (quality >= BANDWIDTH_THRESHOLDS.moderate.value) {
      return BANDWIDTH_THRESHOLDS.moderate;
    } else {
      return BANDWIDTH_THRESHOLDS.excellent;
    }
  },

  isDownLinkExcellentQuality() {
    return this.downLinkNetworkQuality === BANDWIDTH_THRESHOLDS.excellent.value
  },

  isDownLinkPoorQuality() {
    return this.downLinkNetworkQuality === BANDWIDTH_THRESHOLDS.poor.value
  },

  isUpLinkExcellentQuality() {
    return this.upLinkNetworkQuality === BANDWIDTH_THRESHOLDS.excellent.value;
  }
};
